import {
  Card,
  Divider,
  Grid,
  Paper,
  SxProps,
  Theme,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import WSBackButton from "../../Components/BackButton/BackButton";
import {
  getComponentProps,
  unRegisterComponent,
  updateOrRegisterComponent
} from "../../StateManagement/RegisterComponent";
import { WSHeaders } from "../../commonFunctions/HeaderConfig/HeaderConfig";
import WSButton from "../Button/WSButton";
import { WSFilterComponent } from "../Filter/WSFilterComponent";

interface IHeaderProps {
  title: string;
  info?: any;
  type: "card" | "simple";
  usage: "amount" | "text";
  children?: React.ReactNode;
  isBackButton?: boolean;
  url?: string;
  id?: WSHeaders | any;
  isDivider?: boolean;
  headerSx?: SxProps<Theme>;
  actions?: Array<IHeaderListActions>;
  position?: "sticky" | "relative";
}

export interface IHeaderListActions {
  type: "button" | "filter";
  text: string;
  onClick?: (data?: any) => void;
  onFilterChange?: (data: any) => void;
  icon?: any;
  sx?: SxProps<Theme>;
  variant?: "text" | "outlined" | "contained";
  size?: "small" | "medium" | "large";
  color?: "primary" | "secondary" | "success" | "error" | "info" | "warning";
  disabled?: boolean;
  buttonType?: "button" | "submit";
  loading?: boolean;
  filterFields?: any[];
}

export const HeaderList: React.FC<IHeaderProps> = React.memo((props) => {
  const [newUrl, setUrl] = useState<string | undefined>(props?.url);
  const [hasBackButton, setBackButton] = useState<boolean | undefined>(
    props?.isBackButton
  );

  useEffect(() => {
    updateOrRegisterComponent(props?.id, props);
  }, []);

  useEffect(
    () => () => {
      unRegisterComponent(props?.id);
    },
    []
  );

  useEffect(() => {
    const propsed = getComponentProps(props?.id);
    if (propsed) {
      setUrl(propsed.url);
      setBackButton(propsed.isBackButton);
    }
  }, [props?.id]);

  return (
    <>
      {props?.type === "card" && (
        <Paper
          sx={{
            position: props?.position || "sticky",
            top: 0,
            zIndex: 1000,
            backgroundColor: "white",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
          }}
        >
          <Card sx={{ borderRadius: "5px", padding: 3, marginBottom: 2 }}>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <Typography
                fontWeight="bold"
                sx={{
                  color: "#7D79C2",
                  fontSize: "1.15rem",
                  display: "inline-flex",
                  alignItems: "center"
                }}
              >
                {hasBackButton && (
                  <WSBackButton id="btnScheduleBack" url={newUrl} />
                )}{" "}
                {props?.title}
                {props?.info && (
                  <>
                    <Typography
                      component="span"
                      sx={{ mx: 1, color: "#CDCDCE" }}
                    >
                      {" "}
                      |{" "}
                    </Typography>
                    {props?.usage === "amount" ? (
                      <Typography
                        component="span"
                        sx={{ mx: 0, color: "black" }}
                      >
                        ₹ {props?.info}
                      </Typography>
                    ) : (
                      <Typography
                        component="span"
                        sx={{ mx: 0, color: "lightgray" }}
                      >
                        {props?.info}
                      </Typography>
                    )}
                  </>
                )}
              </Typography>

              {props?.actions && (
                <Grid sx={{ display: "flex", gap: 2 }}>
                  {props.actions.map((item: IHeaderListActions) => {
                    if (item.type === "filter") {
                      return (
                        <WSFilterComponent
                          key={item.text}
                          rows={item?.filterFields || []}
                          onFilterChange={item?.onFilterChange || (() => {})}
                        />
                      );
                    } else if (item.type === "button") {
                      return (
                        <WSButton
                          key={item.text}
                          id={item.text}
                          label={item.text}
                          type={item?.buttonType || "button"}
                          size={item?.size || "medium"}
                          sx={item?.sx}
                          onClick={item?.onClick}
                          className="ws-theme-crm"
                          color={item?.color}
                          variant={item?.variant || "contained"}
                          disabled={item.disabled}
                          loading={item?.loading}
                        />
                      );
                    }
                    return null;
                  })}
                </Grid>
              )}
            </Grid>
          </Card>
        </Paper>
      )}
      {props?.type === "simple" && (
        <Grid
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <Typography
            fontWeight="bold"
            sx={{
              color: "#7D79C2",
              fontSize: "1.15rem",
              display: "inline-flex",
              alignItems: "center"
            }}
          >
            {hasBackButton && (
              <WSBackButton id="btnScheduleBack" url={newUrl} />
            )}{" "}
            {props?.title}
            {props?.info && (
              <>
                <Typography component="span" sx={{ mx: 1, color: "#CDCDCE" }}>
                  {" "}
                  |{" "}
                </Typography>

                {props?.usage === "amount" ? (
                  <Typography component="span" sx={{ mx: 0, color: "black" }}>
                    ₹ {props?.info}
                  </Typography>
                ) : (
                  <Typography
                    component="span"
                    sx={{ mx: 0, color: "lightgray" }}
                  >
                    {props?.info}
                  </Typography>
                )}
              </>
            )}
          </Typography>

          {props?.actions && (
            <Grid sx={{ display: "flex", gap: 2 }}>
              {props.actions.map((item: IHeaderListActions) => {
                if (item.type === "filter") {
                  return (
                    <WSFilterComponent
                      key={item.text}
                      rows={item?.filterFields || []}
                      onFilterChange={item?.onFilterChange || (() => {})}
                    />
                  );
                } else if (item.type === "button") {
                  return (
                    <WSButton
                      key={item.text}
                      id={item.text}
                      label={item.text}
                      type={item?.buttonType || "button"}
                      size={item?.size || "medium"}
                      sx={item?.sx}
                      onClick={item?.onClick}
                      className="ws-theme-crm"
                      color={item?.color}
                      variant={item?.variant || "contained"}
                      disabled={item.disabled}
                      loading={item?.loading}
                    />
                  );
                }
                return null;
              })}
            </Grid>
          )}
        </Grid>
      )}
      {props?.isDivider && (
        <Grid item sm={12} xs={12} style={{ marginTop: 10 }}>
          <Divider />
          <br />
        </Grid>
      )}
    </>
  );
});
